import { StreamActions } from "@hotwired/turbo"
import { morph, clearCache } from "../turbo_stream_actions"

StreamActions.morph = morph
StreamActions.clear_cache = clearCache
